import { render, staticRenderFns } from "./TheTeamLayout.vue?vue&type=template&id=20ef0e17&"
import script from "./TheTeamLayout.vue?vue&type=script&lang=js&"
export * from "./TheTeamLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports